import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function PackageList() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // ✅ Ambil data staff login dari localStorage
  const storedStaff = localStorage.getItem("staffData");
  let staffUser = "Unknown Staff";
  try {
    if (storedStaff) {
      const parsed = JSON.parse(storedStaff);
      staffUser = parsed.username || "Unknown Staff";
    }
  } catch (e) {
    console.error("Failed to parse staffData:", e);
  }

  const [newPackage, setNewPackage] = useState({
    package_name: "",
    package_star: 1,
    price: 0,
    package_description: "",
    enable_like: false,
    profit_like: 0,
    enable_view: false,
    profit_view: 0,
    auto_like_view: false,
    duration: 0,
    min_withdraw: 0,
    max_withdraw: 0,
    package_mode: true,
  });

  // ✅ Load data
  const loadPackages = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://api.backofficemain.com/get_package.php");
      const data = await res.json();
      if (Array.isArray(data)) setPackages(data);
      else setPackages([]);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setPackages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPackages();
  }, []);

  const filteredPackages = packages.filter((pkg) =>
    pkg.package_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewPackage({
      ...newPackage,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ✅ Handle Add / Edit Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = { ...newPackage, staff: staffUser };
    let url = "https://api.backofficemain.com/add_package.php";

    if (isEditing) {
      dataToSend.id = editingId;
      url = "https://api.backofficemain.com/update_package.php";
    }

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });

      const result = await res.json();
      if (result.success) {
        alert(isEditing ? "Package updated successfully!" : "Package added successfully!");
        setShowModal(false);
        setIsEditing(false);
        setNewPackage({
          package_name: "",
          package_star: 1,
          price: 0,
          package_description: "",
          enable_like: false,
          profit_like: 0,
          enable_view: false,
          profit_view: 0,
          auto_like_view: false,
          duration: 0,
          min_withdraw: 0,
          max_withdraw: 0,
          package_mode: true,
        });
        loadPackages();
      } else {
        alert("Failed: " + (result.error || ""));
      }
    } catch (err) {
      console.error("Error saving package:", err);
      alert("Error saving package.");
    }
  };

  // ✅ Edit button
  const toBool = (val) => val === true || val === 1 || val === "1";

  const handleEdit = (pkg) => {
    setNewPackage({
      package_name: pkg.package_name || "",
      package_star: pkg.package_star || 1,
      price: pkg.price || 0,
      package_description: pkg.package_description || "",
      enable_like: toBool(pkg.enable_like),
      profit_like: pkg.profit_like || 0,
      enable_view: toBool(pkg.enable_view),
      profit_view: pkg.profit_view || 0,
      auto_like_view: toBool(pkg.auto_like_view),
      duration: pkg.duration || 0,
      min_withdraw: pkg.min_withdraw || 0,
      max_withdraw: pkg.max_withdraw || 0,
      package_mode: toBool(pkg.package_mode),
    });
    setEditingId(pkg.id);
    setIsEditing(true);
    setShowModal(true);
  };

  // ✅ Toggle suspend
  const handleSuspend = async (pkg) => {
    const confirmMsg =
      Number(pkg.is_suspended) === 1
        ? "Unsuspend this package?"
        : "Suspend this package?";
    if (!window.confirm(confirmMsg)) return;

    try {
      const res = await fetch("https://api.backofficemain.com/toggle_suspend.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: pkg.id }),
      });

      const result = await res.json();
      if (result.success) {
        // ✅ Update UI tanpa reload penuh
        setPackages((prev) =>
          prev.map((p) =>
            p.id === pkg.id
              ? { ...p, is_suspended: Number(pkg.is_suspended) === 1 ? 0 : 1 }
              : p
          )
        );
      } else {
        alert("Failed: " + (result.error || ""));
      }
    } catch (err) {
      console.error("Error toggling suspend:", err);
      alert("Error toggling suspend.");
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-semibold">Package Lists</h2>
          <p className="text-muted">
            {loading
              ? "Loading packages..."
              : `You have total ${packages.length} Packages.`}
          </p>
        </div>
        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "250px" }}
            placeholder="Search package..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={() => {
              setNewPackage({
                package_name: "",
                package_star: 1,
                price: 0,
                package_description: "",
                enable_like: false,
                profit_like: 0,
                enable_view: false,
                profit_view: 0,
                auto_like_view: false,
                duration: 0,
                min_withdraw: 0,
                max_withdraw: 0,
                package_mode: true,
              });
              setIsEditing(false);
              setEditingId(null);
              setShowModal(true);
            }}
          >
            + Add Package
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">All Packages</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-bordered align-middle text-center mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-start">Name</th>
                  <th>Stars</th>
                  <th>Price ($)</th>
                  <th>Profit/Like</th>
                  <th>Profit/View</th>
                  <th>Min Withdraw</th>
                  <th>Max Withdraw</th>
                  <th>Status</th>
                  <th>Created By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {!loading && filteredPackages.length > 0 ? (
                  filteredPackages.map((pkg) => {
                    const suspended =
                      Number(pkg.is_suspended) === 1 ||
                      pkg.is_suspended === true ||
                      pkg.is_suspended === "true";
                    return (
                      <tr key={pkg.id}>
                        <td className="text-start">
                          <strong>{pkg.package_name}</strong>
                          <br />
                          <small className="text-muted">
                            Total Bought: {pkg.total_purchase || 0}
                          </small>
                        </td>
                        <td>{pkg.package_star}</td>
                        <td>${pkg.price}</td>
                        <td>${pkg.profit_like}</td>
                        <td>${pkg.profit_view}</td>
                        <td>${pkg.min_withdraw}</td>
                        <td>${pkg.max_withdraw}</td>
                        <td>
                          {suspended ? (
                            <span className="badge bg-danger">Suspended</span>
                          ) : (
                            <span className="badge bg-success">Active</span>
                          )}
                        </td>
                        <td>{pkg.staff}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEdit(pkg)}
                          >
                            Update
                          </button>
                          <button
                            className={`btn btn-sm ${
                              suspended ? "btn-success" : "btn-warning"
                            }`}
                            onClick={() => handleSuspend(pkg)}
                          >
                            {suspended ? "Activate" : "Suspend"}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center text-muted py-3">
                      {loading ? "Loading..." : "No packages found."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Add / Edit */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Edit Package" : "Create New Package"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <h6 className="border-bottom pb-2 mb-3">Basic Information</h6>

                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label className="form-label">Package Name</label>
                      <input
                        type="text"
                        name="package_name"
                        className="form-control"
                        value={newPackage.package_name}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Package Stars</label>
                      <input
                        type="number"
                        name="package_star"
                        className="form-control"
                        value={newPackage.package_star}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Price ($)</label>
                      <input
                        type="number"
                        name="price"
                        className="form-control"
                        value={newPackage.price}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      name="package_description"
                      className="form-control"
                      value={newPackage.package_description}
                      onChange={handleInputChange}
                    />
                  </div>

                  <h6 className="border-bottom pb-2 mb-3">Profit & Features</h6>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="enable_like"
                          checked={newPackage.enable_like}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label">
                          Enable Like Profit
                        </label>
                      </div>
                      <input
                        type="number"
                        name="profit_like"
                        className="form-control mt-2"
                        placeholder="Profit per Like"
                        value={newPackage.profit_like}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="enable_view"
                          checked={newPackage.enable_view}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label">
                          Enable View Profit
                        </label>
                      </div>
                      <input
                        type="number"
                        name="profit_view"
                        className="form-control mt-2"
                        placeholder="Profit per View"
                        value={newPackage.profit_view}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="form-check form-switch mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="auto_like_view"
                      checked={newPackage.auto_like_view}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">
                      Enable Auto Like/View
                    </label>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Duration (hours)</label>
                    <input
                      type="number"
                      name="duration"
                      className="form-control"
                      value={newPackage.duration}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Min Withdraw</label>
                      <input
                        type="number"
                        name="min_withdraw"
                        className="form-control"
                        value={newPackage.min_withdraw}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Max Withdraw</label>
                      <input
                        type="number"
                        name="max_withdraw"
                        className="form-control"
                        value={newPackage.max_withdraw}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="form-check form-switch mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="package_mode"
                      checked={newPackage.package_mode}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">Package Active</label>
                  </div>

                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Create Package
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PackageList;
